/**
 * System module (owner WP0-INT): product and module inventory. Demonstrates
 * manifest discovery end to end and backs the e2e smoke test.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'system',
    title: 'System',
    version: '0.1.0',
    owner: 'WP0-INT',
    entitlementKey: null,
    permissions: ['settings.manage'],
    routes: [{ id: 'about', path: '/system', title: 'System', officeScope: 'practice' }],
    nav: [
      {
        label: 'System',
        group: 'settings',
        routeId: 'about',
        icon: 'info',
        order: 900,
        permission: 'settings.manage',
      },
    ],
    commands: [
      {
        id: 'system.open',
        title: 'Open system information',
        keywords: ['version', 'about'],
        routeId: 'about',
      },
    ],
  }),
  pages: {
    about: () => import('./SystemPage.js'),
  },
});
